import script from "./TextAreaPrimary.vue?vue&type=script&setup=true&lang=js"
export * from "./TextAreaPrimary.vue?vue&type=script&setup=true&lang=js"

import "./TextAreaPrimary.vue?vue&type=style&index=0&id=56df94de&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56df94de"]])

export default __exports__